
import { computed, defineComponent, ref } from "vue";
import { FormDialog } from "@/components/Common";

import { useDialogCommon, useDialogFormData } from "@/hooks";
import {
  initFormData,
  rules,
} from "./editData";

import editAddress from "./edit-address.vue";

import { AddAddress, EditAddress } from "@/api-server/modules/defaultServer";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    formType: { type: String, default: "" },
    visible: { type: Boolean, default: false },
    formData: {
      type: Object,
      default: () => ({ ...initFormData }),
    },
  },

  components: {
    FormDialog,
    editAddress,
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const store = useStore();
    const { visibleRef } = useDialogCommon(props, context);
    const { editFormData } = useDialogFormData(props, initFormData, {
      type: "resetWithPropsFormData",
      visiableRef: visibleRef,
    });

    async function saveFormHandle(data: any) {
      if (props.formType == "add") {
        await AddAddress.fetch({
          ...editFormData.value,
        });

        ElMessage.success({ showClose: true, message: "新增成功" });
      } else if (props.formType == "edit") {
         await EditAddress.fetch({
          ...editFormData.value,
        });

        ElMessage.success({ showClose: true, message: "编辑成功" });
      }

      context.emit("updateSuccess", { ...editFormData.value });
      visibleRef.value = false;
    }

    return {
      rules: rules(editFormData),
      visibleRef,
      editFormData,
      saveFormHandle,
    };
  },
});
